"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";

import rootLogger from "@/lib/logging";

const logger = rootLogger.child({ component: "404-page" });

export function PageNotFoundLogger({
  domain,
  children,
}: {
  domain?: string | null;
  children: React.ReactNode;
}) {
  const pathname = usePathname();

  useEffect(() => {
    logger.warn(
      {
        url: domain ? `${domain}${pathname}` : pathname,
      },
      "Page not found"
    );
  }, [pathname, domain]);

  return children;
}
